// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuickOfferBox .offerSteps[data-v-6418b694]{margin:0 auto;max-height:80px}.QuickOfferBox .tender-text[data-v-6418b694]{color:#404f5b;display:flex;flex-direction:column;text-align:center;width:100%}.QuickOfferBox .tender-text .textarea[data-v-6418b694]{background:hsla(0,0%,100%,.2);border:1px solid rgba(0,0,0,.2);box-shadow:none!important;height:80px;min-height:20px;outline:none!important;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
